module.exports = __webpack_public_path__ + "f1e6cc3826995abaaa1b353c999a684b.svg";